<template>
  <div class="settings-shell py-3">
    <aside class="settings-sidebar">
      <div class="settings-sidebar__header">
        <span class="settings-sidebar__accent" aria-hidden="true"></span>
        <div class="settings-sidebar__heading">
          <h2>Settings</h2>
          <p>System configuration</p>
        </div>
      </div>
      <nav class="settings-nav" aria-label="Settings sections">
        <router-link
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          class="settings-nav__item"
          active-class="is-active"
        >
          <span class="settings-nav__icon" aria-hidden="true" v-html="item.icon"></span>
          <span class="settings-nav__label">{{ item.label }}</span>
        </router-link>
      </nav>
    </aside>

    <section class="settings-content">
      <router-view />
    </section>
  </div>
</template>

<script>
const ICONS = {
  users: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  organisations: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="9" y1="13" x2="9.01" y2="13"/><line x1="9" y1="17" x2="9.01" y2="17"/></svg>',
  roles: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>',
  permissions: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="15" r="4"/><line x1="10.85" y1="12.15" x2="19" y2="4"/><line x1="18" y1="5" x2="20" y2="7"/><line x1="15" y1="8" x2="17" y2="10"/></svg>',
  departments: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
  states: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15"/><path d="M15 6v15"/></svg>',
  branches: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
  invoice: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>',
  callQueues: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/></svg>',
  products: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
  pincodes: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
  quickReplies: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="13" y2="14"/></svg>',
  dropdownitems: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="8 11 12 15 16 11"/></svg>',
  discount: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/><line x1="14" y1="9" x2="9" y2="14"/><circle cx="9.5" cy="9.5" r="0.5"/><circle cx="13.5" cy="13.5" r="0.5"/></svg>',
  shipping: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
  domains: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
}

export default {
  name: 'Settings',
  computed: {
    // The same shell is mounted at two paths: the full admin /settings tree and
    // the hr_manager-scoped /staff tree. Under /staff we expose only the Users
    // section (the HR "create tele sales user" surface); everywhere else the full
    // settings nav renders. Basing this on the path (not the role) keeps the two
    // mounts self-describing and avoids leaking admin sections into /staff.
    isStaffScope () {
      return this.$route.path.startsWith('/staff')
    },
    navItems () {
      if (this.isStaffScope) {
        return [
          { to: '/staff/users', label: 'Users', icon: ICONS.users },
          { to: '/staff/pincodes', label: 'Pincodes', icon: ICONS.pincodes },
          { to: '/staff/quick-replies', label: 'Quick Replies', icon: ICONS.quickReplies },
        ]
      }
      return [
        { to: '/settings/users', label: 'Users', icon: ICONS.users },
        { to: '/settings/roles', label: 'Roles', icon: ICONS.roles },
        // { to: '/settings/permissions', label: 'Permissions', icon: ICONS.permissions },
        { to: '/settings/organisations', label: 'Organisations', icon: ICONS.organisations },
        { to: '/settings/departments', label: 'Departments', icon: ICONS.departments },
        { to: '/settings/states', label: 'States', icon: ICONS.states },
        { to: '/settings/branches', label: 'Branches', icon: ICONS.branches },
        { to: '/settings/invoice', label: 'Invoice & Order', icon: ICONS.invoice },
        { to: '/settings/call-queues', label: 'Call Queues', icon: ICONS.callQueues },
        { to: '/settings/products', label: 'Products', icon: ICONS.products },
        { to: '/settings/pincodes', label: 'Pincodes', icon: ICONS.pincodes },
        { to: '/settings/quick-replies', label: 'Quick Replies', icon: ICONS.quickReplies },
        { to: '/settings/dropdownitems', label: 'Dropdown Items', icon: ICONS.dropdownitems },
        { to: '/settings/discount-presets', label: 'Discount Presets', icon: ICONS.discount },
        { to: '/settings/shipping', label: 'Shipping & COD', icon: ICONS.shipping },
        { to: '/settings/domains', label: 'Domains', icon: ICONS.domains },
      ]
    }
  }
}
</script>

<style scoped>
.settings-shell {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  padding: 0.25rem 0;
}

/* ── Child sidebar ── */
.settings-sidebar {
  flex: 0 0 248px;
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  position: sticky;
  top: 1rem;
  /* Fill the viewport height (minus the app header + page padding) so the
     sidebar always reaches the bottom of the screen on desktop. */
  height: calc(100vh - 5rem);
  max-height: calc(100vh - 5rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.settings-sidebar__header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 1rem 1rem 0.85rem;
  border-bottom: 1px solid #eef1f7;
  background: #fbfcfe;
}

.settings-sidebar__accent {
  width: 4px;
  height: 30px;
  border-radius: 4px;
  background: linear-gradient(180deg, #0e5b46 0%, #16a07a 100%);
  flex-shrink: 0;
}

.settings-sidebar__heading h2 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 700;
  color: #1f2a44;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.settings-sidebar__heading p {
  margin: 0;
  font-size: 0.72rem;
  color: #6b7280;
}

.settings-nav {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.15rem;
  flex: 1 1 auto;
  overflow-y: auto;
}

.settings-nav__item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #4b5563;
  text-decoration: none;
  border: 1px solid transparent;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.settings-nav__item:hover {
  background: #f5fbf8;
  color: #0e5b46;
  text-decoration: none;
}

.settings-nav__item.is-active {
  background: #ecfdf5;
  color: #0e5b46;
  border-color: #c7ebda;
}

.settings-nav__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #16a07a;
  flex-shrink: 0;
}

.settings-nav__item:not(.is-active) .settings-nav__icon {
  color: #6b7280;
}

.settings-nav__item:hover .settings-nav__icon {
  color: #16a07a;
}

.settings-nav__label {
  flex: 1;
  min-width: 0;
}

/* ── Content area ── */
.settings-content {
  flex: 1;
  min-width: 0;
}

/* ── Responsive ── */
@media (max-width: 991px) {
  .settings-shell {
    flex-direction: column;
    gap: 1rem;
    padding: 0.25rem 0;
  }

  .settings-sidebar {
    position: static;
    flex: 1 1 auto;
    width: 100%;
    height: auto;
    max-height: none;
  }

  .settings-sidebar__header {
    padding: 0.75rem 0.85rem 0.65rem;
  }

  .settings-nav {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.5rem;
    gap: 0.3rem;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
  }

  .settings-nav::-webkit-scrollbar {
    height: 4px;
  }

  .settings-nav::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }

  .settings-nav__item {
    flex: 0 0 auto;
    justify-content: center;
    padding: 0.45rem 0.75rem;
    font-size: 0.8rem;
    white-space: nowrap;
  }

  .settings-nav__label {
    flex: 0 0 auto;
  }
}

@media (max-width: 575px) {
  .settings-shell {
    gap: 0.75rem;
    padding: 0 0 0.5rem;
  }

  .settings-sidebar {
    border-radius: 10px;
  }

  .settings-sidebar__header {
    padding: 0.6rem 0.75rem 0.55rem;
    gap: 0.5rem;
  }

  .settings-sidebar__accent {
    height: 26px;
  }

  .settings-sidebar__heading h2 {
    font-size: 0.92rem;
  }

  .settings-sidebar__heading p {
    font-size: 0.68rem;
  }

  .settings-nav {
    padding: 0.4rem;
    gap: 0.25rem;
  }

  .settings-nav__item {
    padding: 0.4rem 0.6rem;
    font-size: 0.76rem;
    gap: 0.45rem;
  }

  .settings-nav__icon {
    width: 16px;
    height: 16px;
  }
}
</style>
